import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import users from './modules/users'
import customers from './modules/customers'
import products from './modules/products'
import reporttypes from './modules/reporttypes'
import missingmappings from './modules/missingmapping'
import reports from './modules/reports'
import breakage from './modules/breakage'
import emailreports from './modules/emailreports'
import reportsets from './modules/reportsets'
import importhistory from './modules/importhistory'
import manualtransactions from './modules/manualtransactions'
import saldo from './modules/saldo'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth, 
    users,
    customers,
    products,
    reporttypes,
    missingmappings,
    reports,
    breakage,
    emailreports,
    reportsets,
    importhistory,
    manualtransactions,
    saldo
  }
})
